import React from 'react';
import styles from './selectableButton.module.sass';

const selectableButton = (props) => {
  return (
    <div className={[styles.buttonContainer, props.className].join(' ')}>
      {
        props.leftIcon && (
          <i className={`icon ${props.leftIcon} ${styles.leftIcon} ${props.selected ? styles.selected : ''}`}/>
        )
      }

      <button
        className={
          [styles.SelectedButton,
            props.buttonClass,
            props.selected ? styles.selected : '',
            props.blue ? styles.blue : '',
            props.showCheckmark ? styles.additionalPadding : ''
          ].join(' ')}
        onClick={props.onClick}

      >
        {props.children}
      </button>
      {
        props.selected && props.showCheckmark && (
          <i className={`icon icon-check-p ${props.selected ? styles.selected : ''}`}/>
        )
      }
    </div>
  )
};

export default selectableButton;
